(function (appComponents) {

	var cartItemCollection = function (parent) {
		var collection = {};
		collection._templates = parent.templates;
		collection._api = parent._api;
		collection._panda = parent._panda;
		collection._product = parent._product;
		collection._cart = parent._cart;
		collection._modals = parent._modals;
		collection._goToPage = parent._goToPage;
		collection.elements = {
			get itemSpaField() {
				return $("[pc-container='cart--item-spa-field']");
			},
			get itemSpaSelector() {
				return $("[pc-container='cart--item-spa-selector']");
			},
			get itemQtyField() {
				return $("[pc-container='cart--item-qty']");
			},
			get itemTableCellSpa() {
				return $("[pc-container='cart--table-cell-spa']");
			},
			get itemTableCellPanda() {
				return $("[pc-container='cart--table-cell-panda']");
			},
			get totalPrice() {
				return $("[pc-container='cart--total-price']");
			},
			get itemExtPrice() {
				return $("[pc-container='cart--item-ext-price']");
			},
		};
		// item actions does not lead to complete model sync - rewrite promise actions to fully sync if needed
		var cartItemPrototype = {
			get isChecked() {
				return this._parentElement.find('[pc-container="cart--choose-one-item"]').is(':checked');
			},
			updateViewExtPrice: function (extPrice) {
				var extPriceElement = collection.elements.itemExtPrice;
				this._parentElement.find(extPriceElement).text(extPrice);
			},
			updateQty: function () {
				var self = this;
				var qtyField = collection.elements.itemQtyField;
				var qty = this._parentElement.find(qtyField).val();

				if (qty == this.quantity) return;

				if (qty < this.product.minOrderQuantity) qty = this.product.minOrderQuantity;

				var itemData = {
					productCode: self.product.code,
					qty: qty
				};
				collection._api.cart.update([itemData]).then(function (res) {
					if (res && res.status == 200) {
						var totalPrice = res.body.cartData.totalPrice.formattedValue;
						var extItemPrice = res.body.cartData.entries[self.entryNumber].totalPrice.formattedValue;

						collection.updateViewTotalPrice(totalPrice);
						self.updateViewExtPrice(extItemPrice);

						self.quantity = qty;
					}
				});
			},
			applySpaValueToView: function (spaValue) {
				// flag to prevent single item spa event firing
				var isGlobal = true;
				if (spaValue == " " || this.product.spaList.indexOf(spaValue) > -1) {
					this._parentElement.find(collection.elements.itemSpaSelector).val(spaValue).trigger("change", [isGlobal]);
				} else {
					this._parentElement.find(collection.elements.itemSpaSelector).val("not-listed").trigger("change", [isGlobal]);
					this._parentElement.find(collection.elements.itemSpaField).val(spaValue);
				}
			},
			getPandaData: function () {
				var spaValue;

				var selectorValue = this._parentElement.find(collection.elements.itemSpaSelector).val();
				if (selectorValue == "not-listed") {
					spaValue = this._parentElement.find(collection.elements.itemSpaField).val();
				} else if (selectorValue != "listed") {
					spaValue = selectorValue;
				} else {
					spaValue = "";
				}

				var qty = this._parentElement.find(collection.elements.itemQtyField).val();

				var objectToReturn = {
					spa: spaValue,
					qty: qty
				};

				if (this.isCustomMotor || this.specialMotor) {
					objectToReturn.pk = this.pk;
				} else {
					objectToReturn.productCode = this.product.code;
				}

				return objectToReturn;
			},
			updateViewAfterPandaCheck: function (pandaData) {
				var html = collection._templates.pandaSection(this);
				this._parentElement.find(collection.elements.itemTableCellPanda).remove();
				this._parentElement.find(collection.elements.itemTableCellSpa).after(html);

				collection.updateViewTotalPrice(pandaData.total);
			},
			setPandaData: function (products) {
				if (this.isCustomMotor || this.specialMotor) {
					this._panda = products[this.pk];
				} else {
					this._panda = products[this.product.code];
				}
			},
			setItemSpa: function () {
				var self = this;
				var pandaData = this.getPandaData();
				var isCartRequest = true;
				collection._panda.checkPriceAndAvailability([pandaData], isCartRequest).then(function (pandaData) {
					// self._panda =  pandaData.products[self.product.code];
					self.setPandaData(pandaData.products);
					self.updateViewAfterPandaCheck(pandaData);
				});
			},
			remove: function () {
				var self = this;
				collection._cart.removeItemByPk(this.pk).then(function (res) {
					if (res && res.status == 200) {
						self._parentElement.remove();
						if (res.body.cartSize == 0) {
							collection._api.cart.detachOrderFromCart().then(function (res) {
								if (res.status != 200) {
									console.log(res);
								}
								collection._goToPage("index");
							});
						} else {
							var totalPrice = res.body.total.formattedValue;
							collection.updateViewTotalPrice(totalPrice);
						}
					}
				});
			},
			showPandaMoreInfo: function () {
				collection._panda.showDetails(this);
			},
			downloadDataPack: function (type) {
				collection._product.downloadDataPack(this.product.stockId, type);
			},
			showDetails: function () {
				if (this.isTestAdder) return;

				collection._product.showDetails(this.product);
			},
		};
		collection.setCollection = function (items) {

			this.collection = items;
			$.each(this.collection, function (index, el) {
				this._parentElement = $("[pc-container='cart--item'][pc-value='" + el.entryNumber + "']");
				this.__proto__ = cartItemPrototype;
			});
		};

		collection.updateViewTotalPrice = function (totalPrice) {
			this.elements.totalPrice.text(totalPrice);
		};

		collection.setGlobalSpa = function (spaValue) {
			var pandaArray = [];
			var productsToCheckSpa = [];
			$.each(this.collection, function () {
				if (!this.product.pcPart && !this.isTestAdder) {

					this.applySpaValueToView(spaValue);

					var pandaData = this.getPandaData();
					pandaArray.push(pandaData);
					productsToCheckSpa.push(this);
				}
			});

			if (!productsToCheckSpa.length) return;

			var isCartRequest = true;

			collection._panda.checkPriceAndAvailability(pandaArray, isCartRequest).then(function (pandaData) {

				var errorProducts = [];
				var successProducts = [];

				for (var key in pandaData.products) {
					if (pandaData.products[key].errorCode || pandaData.products[key].errorMsg) {
						pandaData.products[key].prodNum = key;
						pandaData.products[key].quoteNo = spaValue.split("-")[0];
						errorProducts.push(pandaData.products[key]);
					} else {
						successProducts.push(pandaData.products[key]);
					}
				}

				if (errorProducts.length) {
					collection._modals.warning.showAppliedPandaInCartMessage(successProducts, errorProducts);
				} else {
					collection._modals.success.showAppliedPandaInCartMessage(successProducts);
				}

				productsToCheckSpa.forEach(function (el, idx, arr) {
					// el._panda = pandaData.products[el.product.code];
					el.setPandaData(pandaData.products);
					el.updateViewAfterPandaCheck(pandaData);
				});

			}).fail(function (e) {
				console.log(e);
			});
		};

		collection.findItemByEntryNumber = function (entryNumber) {
			var entryToReturn = null;
			this.collection.forEach(function (el) {
				if (el.entryNumber == entryNumber) {
					entryToReturn = el;
				}
			});
			return entryToReturn;
		};

		collection.setItemQty = function (entryNumber) {
			this.findItemByEntryNumber(entryNumber).updateQty();
		};

		//check and remove as not used
		// collection.removeItemsByIdx = function (entriesIdxsArrayToDelete) {

		// 	cartOverview._cart.removeItems(entriesIdxsArrayToDelete).then(function (res) {
		// 		if (res && res.status == 200) {
		// 			var totalPrice = res.body.cartData.totalPrice.formattedValue;
		// 			collection.updateViewTotalPrice(totalPrice);

		// 			collection.findItemByEntryNumber(entryNumber).remove();

		// 		}
		// 	});
		// };

		collection.removeCheckedItems = function () {
			var pksToRemove = [];
			var checkedElements = [];

			this.collection.forEach(function (el) {
				if (el.isChecked) {
					pksToRemove.push(el.pk);
					checkedElements.push(el._parentElement);
				}
			});
			collection._cart.removeItemByPk(pksToRemove.toString()).then(function (res) {
				if (res && res.status == 200) {
					if (res.body.cartSize == 0) {
						collection._api.cart.detachOrderFromCart().then(function (res) {
							if (res.status != 200) {
								console.log(res);
							}
							collection._goToPage("index");
						});
					} else {
						checkedElements.forEach(function (el) {
							el.remove();
						});
						var totalPrice = res.body.total.formattedValue;
						collection.updateViewTotalPrice(totalPrice);
						$('[pc-container="cart--delete-items"]').attr("disabled", true);
					}
				}
			});
		};

		collection.showPandaMoreInfo = function (entryNumber) {
			this.findItemByEntryNumber(entryNumber).showPandaMoreInfo();
		};


		return collection;
	};

	if (appComponents.pageComponents == null) appComponents.pageComponents = {};
	if (appComponents.pageComponents.cartOverview == null) appComponents.pageComponents.cartOverview = {};
	appComponents.pageComponents.cartOverview.cartItemCollection = cartItemCollection;

	window.appComponents = appComponents;

})(window.appComponents || {});